import { ExpressionWithTypeArguments } from "typescript";
import { SquareMultiplierEnum } from "./Enums";

export default class SquareContents {
    char:string;
    pointValue: number;
    multiplier: SquareMultiplierEnum = SquareMultiplierEnum.Normal;
    classes: string = '';

    constructor(char: string, pointValue: number) {
        this.char = char;
        this.pointValue = pointValue;
      }
}